import { BcMenu } from './BcMenu/BcMenu'
import { McmMenu } from './McmMenu/McmMenu'
import { RptMenu } from './RptMenu/RptMenu'

export const ProductMenu = ({ product }) => {
  switch (product) {
    case 'mcm':
      return <McmMenu />
    case 'rpt':
      return <RptMenu />
    case 'bc':
    default:
      return <BcMenu />
  }
}
